import { colors } from '@/assets/styles/colors';


const OVERTIME_GREEN_THRESHOLD = 70;
const OVERTIME_RED_THRESHOLD = 45;
const TARDINESS_RED_THRESHOLD = 70;
const TARDINESS_GREEN_THRESHOLD = 45;
// Debe reflejar AttendanceConstants.ABSENCE_UNJUSTIFIED_RED_THRESHOLD del backend.
const ABSENCE_UNJUSTIFIED_RED_THRESHOLD = 30;

export function getOvertimeColor(percentage: number): string {
  if (percentage >= OVERTIME_GREEN_THRESHOLD) return colors.feedback.success300;
  if (percentage <= OVERTIME_RED_THRESHOLD) return colors.feedback.error300;
  return colors.feedback.alert300;
}

export function getTardinessColor(percentage: number): string {
  if (percentage >= TARDINESS_RED_THRESHOLD) return colors.feedback.error300;
  if (percentage <= TARDINESS_GREEN_THRESHOLD) return colors.feedback.success300;
  return colors.feedback.alert300;
}

export function getAbsenceColor(percentage: number): string {
  return percentage >= ABSENCE_UNJUSTIFIED_RED_THRESHOLD
    ? colors.feedback.error300
    : colors.primary.dark;
}
